<template>
  <div class="mw1200" style="margin-bottom: 160px" :style="{marginLeft: pc?'auto':'20px'}">
    <a-carousel :autoplaySpeed="5000" arrows autoplay :slidesToShow="pc?3:1" :dots="false" :touchMove="false">
      <!--  eslint-disable-next-line vue/no-unused-vars-->
      <div @mouseenter="l = true" @mouseleave="l = false" slot="prevArrow" slot-scope="props" class="custom-slick-arrow" style="left: 0;top: calc(100% + 60px)">
        <svg v-if="!l" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             width="10px" height="18px"
        >
          <image  x="0px" y="0px" width="10px" height="18px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAQAAADIvofAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfkAxkNMzIf1DYSAAAAn0lEQVQY023QoQ7CQBBF0bsDCAxFkJCgsWh8EzYkYPmezf4OFhSEilKDxgEaBaamAgGm6U5bRp5MJm+e+aLHz9lx7zbowAAxYdPPOBORY0VRQkTByl1E0YiCtctAGpQASJugY6acGGsC4ciED5tA5U3A6LzCgic9tj5W6B4sedFnH1jAXYnrLNDm6vcqrXVZvZCUITnW6D7L6t7mT8m3HxMePZkXhEFeAAAAAElFTkSuQmCC" />
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             width="10px" height="18px">
          <image  x="0px" y="0px" width="10px" height="18px"  xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAMAAABVab95AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAQlBMVEX///9zIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiL///8/RlrmAAAAFHRSTlMAN+rF8ewt8Ov2PEIk5d/6S0zvxBWBDhwAAAABYktHRACIBR1IAAAAB3RJTUUH5AMZEDAg074kugAAAERJREFUCNdjYIAARiZmGItFhBXCYmMXYWGEsDhEOLngLG6cLB5eGIuBT4RfgAHOFIQykRQgacPP5oKxhWDOQXYkyOnCAEdXA2NijeiUAAAAAElFTkSuQmCC" />
        </svg>
      </div>
      <!--  eslint-disable-next-line vue/no-unused-vars-->
      <div @mouseenter="r = true" @mouseleave="r = false" slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="left: 30px;top: calc(100% + 60px)">
        <svg v-if="!r" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             width="10px" height="18px">
          <image  x="0px" y="0px" width="10px" height="18px"  xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAQAAADIvofAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfkAxkQNQycEbwcAAAAp0lEQVQY023QoQvCUBDH8e87MQgyi/4JYjKvCMqCDJ7+Tc/3F1kU3MKShmWLwWCyaJCVxRmc7r3hlYPPccePU5sTY9YmxylhwojUhj5qCgISO3XQ5GhKBmQNC5gjK0qGDQuAyXyWz8xnVf3O24gdPe7MHQSr2dLlJm4+VN3+rUuLnsTmKi2KzLmO5BOoCjsjdQk6KuRAnxeLL4GwJ6AgbgiECw+W/pPfnw89X2pQ4m8AAAAASUVORK5CYII=" />
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             width="10px" height="18px">
          <image  x="0px" y="0px" width="10px" height="18px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAMAAABVab95AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAQlBMVEX///9zIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiJzIiL///8/RlrmAAAAFHRSTlMAxeo37PHwLTz260LlJEv630zvxN776gwAAAABYktHRACIBR1IAAAAB3RJTUUH5AMZDTYnD34mvAAAAEFJREFUCNdjYGRiZoACFhFWGJuZVYSNHcrm4BThgrG5iWPz8ELZfPwiAlCmIJyJUIDQho2FsBjoHCF2DEcKw50OAFKXA4YJR8OWAAAAAElFTkSuQmCC" />
        </svg>
      </div>
      <template v-if="pc">
        <div v-for="(item, index) in peopleList" :key="index" style="border-left: 1px #808080 solid;position: relative;padding-right:40px">
          <div style="display: flex">
            <div style="padding: 0 10px">
              <img :src="`/acnImg/people/${item.ename}.png`" width="105" height="105" style="cursor: pointer" @click="goPeople(item)">
              <div style="position: absolute;bottom: 0;cursor: pointer" @click="goPeople(item)">
                <img src="@/assets/arrow.png" />
                <div style="width: 26px;height: 4px;background: #7F1F20;margin-top: 10px"></div>
              </div>
            </div>
            <div style="padding-top: 35px">
              <div style="font-size: 18px;color: #7F1F20">{{isEn ? item.ename : item.cname}}</div>
              <div v-html="isEn ? item.etitle1 + '<br>' + item.etitle2 : item.ctitle1 + '<br>' + item.ctitle2" style="font-style: italic;line-height: 18px;overflow: hidden;font-size: 15px;
                           display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;"></div>
              <div v-html="isEn ? item.ebio : item.cbio"
                   style="line-height: 21px;margin-top: 10px;max-height: 110px;font-size: 15px;
                            display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 5;
                            overflow: hidden;width: 100%;color: #595959;font-size: 15px"></div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div v-for="(item, index) in peopleList" :key="index" style="border-left: 1px #808080 solid;position: relative;padding-right:40px">
          <div style="display: flex">
            <div style="padding: 0 10px">
              <img :src="`/acnImg/people/${item.ename}.png`" width="130" height="130" style="cursor: pointer" @click="goPeople(item)">
              <div style="position: absolute;bottom: 0;cursor: pointer" @click="goPeople(item)">
                <img src="@/assets/arrow.png" />
                <div style="width: 26px;height: 4px;background: #7F1F20;margin-top: 10px"></div>
              </div>
            </div>
            <div style="padding-top: 35px">
              <div style="font-size: 26px;color: #7F1F20">{{isEn ? item.ename : item.cname}}</div>
              <div v-html="isEn ? item.etitle1 + '<br>' + item.etitle2 : item.ctitle1 + '<br>' + item.ctitle2" style="font-style: italic;line-height: 23px;overflow: hidden;font-size: 20px;
                           display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;"></div>
              <div v-html="isEn ? item.ebio : item.cbio" :class="{f20: !pc}"
                   style="line-height: 30px;margin-top: 10px;
                            display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;
                            overflow: hidden;width: 100%;color: #595959;font-size: 15px"></div>
            </div>
          </div>
        </div>
      </template>
    </a-carousel>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
export default {
  name: 'people',
  data () {
    return {
      peopleList: [],
      l: false,
      r: false
    }
  },
  computed: {
    ...mapGetters(['isEn', 'pc'])
  },
  methods: {
    async query () {
      this.peopleList = await request.get('/people/list')
    },
    goPeople (p) {
      if (p.sales) {
        this.$router.push({ name: 'Company', params: { name: 'professionals', tab: '0' } })
      } else if (p.regionalRep) {
        this.$router.push({ name: 'Company', params: { name: 'professionals', tab: '1' } })
      } else if (p.advisory) {
        this.$router.push({ name: 'Company', params: { name: 'professionals', tab: '2' } })
      }
    }
  },
  mounted () {
    this.query()
  }
}
</script>
